export const tagsMixins = {
  methods: {
    // 页签
    setVisitedView(arr) {
      this.$emit('setVisitedView', arr)
    },
    // 页签缓存
    setCachedViews(arr) {
      this.$emit('setCachedViews', arr)
    },
    // 设置matched属性不可枚举
    matchedViews() {
      this.visitedViews.forEach((item, index) => {
        item.matched && Object.defineProperty(item, 'matched', { enumerable: false })
        if (item.meta.affix && index !== 0) {
          this.visitedViews.splice(index, 1)
        }
      })
    },
    // 新增页签
    addVisitedTag(tag) {
      const { name } = tag
      this.addCachedTag(tag)
      if (name) {
        const temp = {
          fullPath: tag.fullPath,
          meta: {
            title: 'noName',
            ...tag.meta
          },
          // name: tag.name,
          params: tag.params,
          path: tag.path,
          query: tag.query
        }
        if (this.visitedViews.some((v) => v.fullPath === temp.fullPath)) return
        this.visitedViews[temp.meta.affix ? 'unshift' : 'push'](
          Object.assign({}, temp, {
            title: temp.meta.title || 'noName'
          })
        )
        this.matchedViews()
        this.setVisitedView(this.visitedViews)
      }
    },
    // 新增页签缓存
    addCachedTag(tag) {
      if (this.cachedViews.includes(tag.path) || tag.path.indexOf('redirect') !== -1) return
      if (!tag.meta.noCache) {
        this.cachedViews.push(tag.path)
      }
      this.setCachedViews(this.cachedViews)
    },
    // 关闭页签
    deleteVisitedTag(tag) {
      return new Promise(resolve => {
        const index = this.visitedViews.findIndex(item => item.fullPath === tag.fullPath)
        if (index < 0) return
        this.visitedViews.splice(index, 1)
        resolve(this.visitedViews)
        this.setVisitedView(this.visitedViews)
        this.deleteCachedTag(tag)
      })
    },
    // 关闭页签缓存
    deleteCachedTag(tag) {
      return new Promise(resolve => {
        for (const i of this.cachedViews) {
          if (i === tag.path) {
            const index = this.cachedViews.indexOf(i)
            this.cachedViews.splice(index, 1)
            break
          }
        }
        resolve()
        this.setCachedViews(this.cachedViews)
      })
    },
    // 关闭其他页签
    deleteOthersVisitedTags(tag) {
      return new Promise(resolve => {
        const arr = this.visitedViews.filter(v => {
          return v.meta.affix || v.fullPath === tag.fullPath
        })
        this.matchedViews()
        resolve()
        this.setVisitedView(arr)
        this.deleteOthersCachedTags(tag)
      })
    },
    // 关闭其他页签缓存
    deleteOthersCachedTags(tag) {
      const view = this.cachedViews.find(item => item === tag.fullPath)
      const arr = [view]
      this.setCachedViews(arr)
    },
    // 关闭全部页签
    deleteAllVisitedTags() {
      return new Promise(resolve => {
        const arr = this.visitedViews.filter((tag) => tag.meta.affix)
        resolve(arr)
        this.setVisitedView(arr)
        this.deleteAllCachedTags()
      })
    },
    // 关闭全部页签缓存
    deleteAllCachedTags() {
      this.setCachedViews([])
    },
    // 关闭左侧页签
    deleteLeftVisitedTags(tag) {
      const index = this.visitedViews.findIndex(item => item.fullPath === tag.fullPath)
      const arr = this.visitedViews.slice(index, this.visitedViews.length)
      arr.unshift(this.visitedViews[0])
      this.setVisitedView(arr)
      this.deleteLeftCachedTags(tag)
    },
    // 关闭左侧页签缓存
    deleteLeftCachedTags() {
      const arr = this.cachedViews.map(item => this.visitedViews.find(s => s.fullPath === item)).filter(item => item)
      this.setCachedViews(arr)
    },
    // 关闭右侧页签
    deleteRightVisitedTags(tag) {
      return new Promise(resolve => {
        const index = this.visitedViews.findIndex(item => item.fullPath === tag.fullPath)
        const arr = this.visitedViews.slice(0, index + 1)
        resolve(arr)
        this.setVisitedView(arr)
        this.deleteRightCachedTags(tag)
      })
    },
    // 关闭右侧页签缓存
    deleteRightCachedTags() {
      const arr = this.cachedViews.map(item => this.visitedViews.find(s => s.fullPath === item)).filter(item => item)
      this.setCachedViews(arr)
    }
  }
}
